import React from 'react';
import { Table } from 'semantic-ui-react';

// GLobal Components
import RoleTable from 'components/RoleTable';

// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import { ADMIN } from 'components/RoleGate/constants';

import { IncompleteDisposalSprayEvent } from '../../types';
import DisposalTableHeader from '../CompleteCropSprayEventFormTableHeader/components/DisposalTableHeader';
import CompleteCropSprayEventFormTableDisposalsRow from './components/CompleteCropSprayEventFormTableDisposalsRow';

interface OwnProps {
    incompleteSprayEvents: Record<string, IncompleteDisposalSprayEvent[]>;
}

type Props = OwnProps;

export default function CompleteCropSprayEventFormTableDisposals(
    props: Props
): React.ReactElement {
    const { incompleteSprayEvents } = props;

    return (
        <ResponsiveTable>
            <RoleTable requiredRoles={[ADMIN]}>
                <DisposalTableHeader />
                <Table.Body>
                    {Object.keys(incompleteSprayEvents).map((startDate) =>
                        incompleteSprayEvents[startDate].map(
                            (sprayEvent, index) => (
                                <CompleteCropSprayEventFormTableDisposalsRow
                                    sprayEvent={sprayEvent}
                                    index={index}
                                    key={sprayEvent.uuid}
                                />
                            )
                        )
                    )}
                </Table.Body>
            </RoleTable>
        </ResponsiveTable>
    );
}
